import PropTypes from "prop-types";

/**
 * PropTypes for FaqAccordion component
 * @typedef {Object} FaqAccordionProps
 * @property {string} question - Question text
 * @property {string} answer - Answer text (supports HTML)
 * @property {boolean} [isActive] - Whether this accordion is currently open
 * @property {function} [onToggle] - Callback when accordion is toggled
 */
export const faqAccordionPropTypes = {
  question: PropTypes.string.isRequired,
  answer: PropTypes.string.isRequired,
  isActive: PropTypes.bool,
  onToggle: PropTypes.func,
};
